import styled from 'styled-components';
import { JColors } from 'themes/colors';

export const Container = styled.div``;

export default {
  Container: {
    padding: '15px 0',
  },
  HeaderTitle: {
    fontFamily: 'AvenirNext-Medium',
    fontSize: '26px',
    lineHeight: '1.3em',
    color: JColors.mediumGrey,
    marginBottom: '20px',
    textAlign: 'center',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  GroupPanel: {
    marginBottom: '5px',
    textAlign: 'left',
  },
  Title: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    color: JColors.lightGrey,
    marginBottom: '15px',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  GroupTitle: {
    fontSize: '13px',
    fontFamily: 'AvenirNext-Medium',
    color: '#848484',
    letterSpacing: '0.3px',
    paddingLeft: '15px',
    paddingRight: '15px',
    marginBottom: '10px',
    textAlign: 'left',
  },
  GroupField: {
    marginBottom: '20px',
    textAlign: 'left',
  },
  Field: {
    marginBottom: '15px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  TextField: {
    resize: 'vertical',
    minHeight: '135px',
  },
  labelHours: {
    fontSize: '10px',
    color: JColors.lightGrey,
    fontFamily: 'AvenirNext-DemiBold',
  },
  FieldButton: {
    marginBottom: '0px',
  },
  buttonControl: {
    minWidth: '150px',
  },
};
